import { httpRequest } from '@/lib/http-client';
import { OrderFilterParams, ProductOrder } from '../types/product-order';

export class ProductOrderService {
  static async createOrder(userId: string, organizationId: string, manualOrderNumber?: string) {
    console.log('📤 Creating order with:', { userId, organizationId, manualOrderNumber });

    try {
      const data = await httpRequest('/api/orders', {
        method: 'POST',
        data: {
          organizationId,
          manualOrderNumber
        }
      });

      console.log('✅ Order created:', data);
      return data;
    } catch (error) {
      console.error('💥 Error creating order:', error);
      throw error instanceof Error ? error : new Error('Unknown error occurred');
    }
  }

  static async getOrders(): Promise<ProductOrder[]> {
    console.log('📤 Fetching orders');

    try {
      const data = await httpRequest('/api/orders', {});
      console.log('✅ Orders fetched:', { count: data?.length });
      return data;
    } catch (error) {
      console.error('💥 Error fetching orders:', error);
      throw error instanceof Error ? error : new Error('Unknown error occurred');
    }
  }

  /**
   * Get orders with filtering options
   * @param options Object containing filter options
   */
  static async getOrdersWithFilter(
    options: {
      limit?: number;
      days?: number;
      status?: string | string[];
    }
  ): Promise<ProductOrder[]> {
    const { limit = 20, days, status } = options;
    console.log('📤 Fetching filtered orders:', { limit, days, status });

    try {
      // Build query parameters
      const queryParams = new URLSearchParams();
      if (limit) queryParams.append('limit', limit.toString());
      if (days) queryParams.append('days', days.toString());
      if (status) {
        if (Array.isArray(status)) {
          status.forEach(s => queryParams.append('status', s));
        } else {
          queryParams.append('status', status);
        }
      }

      const endpoint = `/api/orders?${queryParams.toString()}`;
      const data = await httpRequest(endpoint, {});
      
      console.log('✅ Filtered orders fetched:', { count: data?.length, filters: { limit, days, status } });
      return data;
    } catch (error) {
      console.error('💥 Error fetching filtered orders:', error);
      throw error instanceof Error ? error : new Error('Unknown error occurred');
    }
  }

  static async updateOrderStatus(orderId: string, status: 'draft' | 'processing' | 'completed' | 'archived') {
    console.log('📤 Updating order status:', { orderId, status });

    try {
      await httpRequest(`/api/orders/${orderId}/status`, {
        method: 'PUT',
        data: { status }
      });
      console.log('✅ Order status updated:', { orderId, status });
    } catch (error) {
      console.error('💥 Error updating order status:', error);
      throw error instanceof Error ? error : new Error('Unknown error occurred');
    }
  }

  /**
   * Get a specific order by ID
   * @param orderId ID of the order to fetch
   */
  static async getOrderById(orderId: string): Promise<ProductOrder> {
    console.log('📤 Fetching order by ID:', orderId);

    try {
      const data = await httpRequest(`/api/orders/${orderId}`, {});
      
      console.log('✅ Order fetched:', { id: data?.id, orderNumber: data?.order_number });
      return data;
    } catch (error) {
      console.error('💥 Error fetching order:', error);
      throw error instanceof Error ? error : new Error('Unknown error occurred');
    }
  }
}